'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');

$(document).ready(function () {
    $('body').on('click', '#applyMyDayVoucherBtn', function (e) {
        e.preventDefault();
        var $this = $(this);
        var successMsg = $this.data('success-msg');
        var errorMsg = $this.data('error-msg');

        var ajaxUrl = $this.data('url');
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                if (data.myDayDiscountApplied) {
                    $this.addClass('d-none');
                    $('.my-day-remove-btn').removeClass('d-none');
                    $('.my-day-discount-info').removeClass('d-none');
                    toastMessageHelper.showNotification('success', data.message || successMsg);
                    $('#maincontent').trigger('cart:refreshCartSummary', {
                        isCartPage: true
                    });
                } else {
                    toastMessageHelper.showNotification('', data.message || errorMsg);
                }
            },
            error: function () {}
        });
    });

    // Remove logic
    $('body').on('click', '#removeMyDayVoucherBtn', function (e) {
        e.preventDefault();
        var $this = $(this);
        var ajaxUrl = $this.data('url');
        var successMsg = $this.data('success-msg');
        // var errorMsg =  $this.data('error-msg');
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                if (!data.result.isEligibleForMyDay) {
                    $('.my-day-discount-info').addClass('d-none');
                    data.result.totalOriginalPriceAdd.forEach(function (item) {
                        var $totalPrice = $('.item-total-' + item.uuid + ' .line-item-total-price-amount');
                        if ($totalPrice.length) {
                            $totalPrice.text(item.originalPrice);
                        }
                        var $strike = $('.item-total-' + item.uuid + ' .strike-through');
                        if ($strike.length) {
                            $strike.text();
                            $strike.val();
                            $strike.hide();
                        }
                    });
                    $('.my-day-add-btn').removeClass('d-none');
                    $('.my-day-remove-btn').addClass('d-none');
                }
                $.spinner().stop();
                toastMessageHelper.showNotification('success', data.result.message || successMsg);

                // Remove promo code cards from the UI to keep in sync with backend
                $('.coupon-discount-row.applied .discount-voucher-card').fadeOut(200, function () {
                    $(this).remove();
                });

                // Remove prepaid gift voucher cards from the UI to keep in sync with backend
                $('.prepaid-gift-discount-row.applied .discount-voucher-card').fadeOut(200, function () {
                    $(this).remove();
                });

                // Remove discount voucher cards from the UI to keep in sync with backend
                $('.discount-discount-row.applied .discount-voucher-card').fadeOut(200, function () {
                    $(this).remove();
                });
                $('.benefit-box').removeClass('btnDisabled');
                $('#maincontent').trigger('cart:resetLoyalityPoints', data.basketModel);
                $('#maincontent').trigger('cart:refreshCartSummary', {
                    isCartPage: true
                });
                $('.redeem-btn').removeClass('d-none').prop('disabled', true);
                $('.redeemed-section, .protection-plan .benefits, .plan-card .benefits').removeClass('d-flex').addClass('d-none');
                $('.benefit-box').removeClass('selected');
                $('.open-status-redeem-btn').each(function () {
                    var plan = $(this).data('plan');
                    if (typeof plan === 'string') {
                        plan = JSON.parse(plan);
                    }
                    if (plan.totAmt > 0) {
                        $(this).removeClass('d-none');
                    }
                });
                $('.plan-footer .see-benefits').removeClass('d-none');
                $('.plan-footer .close-benefits').addClass('d-none');
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
});
